import { T } from 'react-translator-component';

/**
 * `rtc-lang` (gravado por src/useApp.ts:124) guarda a chave do Config.list, não uma tag
 * de idioma. Quem formata número e data precisa da tag BCP-47 correspondente.
 */
const LOCALE_TAG: Record<string, string> = {
  br: 'pt-BR',
  en: 'en-US',
  es_co: 'es-CO',
  es_ec: 'es-EC',
  es_uy: 'es-UY',
};

const DEFAULT_LOCALE_TAG = 'pt-BR';

/**
 * T() devolve um array de nós do react-html-parser, não uma string. Onde o valor
 * traduzido precisa SER string — mensagem de validação do Formik, célula de tabela,
 * template literal — passe por aqui.
 *
 * Sempre em tempo de chamada, nunca em constante de módulo: o arquivo de idioma só é
 * escolhido depois do fetch de src/useApp.ts, então traduzir no load do módulo
 * congelaria o texto em português.
 */
export const t = (key: string): string => String(T(key));

/** Tag BCP-47 do idioma ativo, para toLocaleString/Intl. */
export const activeLocaleTag = (): string =>
  LOCALE_TAG[localStorage.getItem('rtc-lang')] || DEFAULT_LOCALE_TAG;
